import { Component } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule, } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-member-insurer-profile',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, MatInputModule, MatFormFieldModule,],
  templateUrl: './member-insurer-profile.component.html',
  styleUrl: './member-insurer-profile.component.scss'
})
export class MemberInsurerProfileComponent {
  closeDialog() {
    this.dialogref.close()
  }
  onclose() {
    this.dialogref.close
  }
  onEditForm() {
    console.log(this.editform.value)
  }
  constructor(private fb: FormBuilder, public dialogref: MatDialogRef<MemberInsurerProfileComponent>) {
    this.editform = this.fb.group({
      email: new FormControl('', [Validators.required, Validators.email]),
      phonenumber: new FormControl('', [Validators.required]),
      adress: new FormControl(''),
      designation: new FormControl('')
    })

  }
  editable: boolean = false;
  editform: FormGroup<any>;


  onEdit() {
    this.editable = true;
  }

}
